import React, { useState } from "react";
import { Box, Typography, Button, Modal } from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";

const DeleteModal = ({
  selected,
  customText,
  deleteCallBack,
  open,
  setOpen,
}) => {
  // const handleTournamentDelete = () => {};
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {customText}
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={() => setOpen(false)}>
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                deleteCallBack.current && deleteCallBack.current(selected);
                setOpen(false);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteModal;
